import Notification from '@/components/notifications/Notification'

export default class OvertimeNotification extends Notification {
  constructor(notification) {
    super(notification)
  }

  navigate(router, query) {
    router.push({
      query: {
        ...query,
        ...this.routeQuery(),
      },
    })
  }

  getCommenter() {
    return this.notification.data.commentator
  }

  getType() {
    return 'overtime'
  }

  _getResourceKey() {
    return this.notification.data.overtime_id
  }
}
